import React, { useCallback, useEffect , useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import styled from "styled-components";
import { Row, Col, Card, Table, Pagination, Button, Badge } from "react-bootstrap";
import PageTitle from "../../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { deleteTypeOfClaimData, getTypeOfClaimList, updateTypeOfClaimStatusData } from "../../../redux/actions/TypeOfClaimActions";
import RoundedPagination from "../../../Components/Paginate";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../../redux/actions/AuthActions";
import useDebounce from "../../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from "../../../util/generalUtills";
import Preloader from "../../../Components/Preloader";
import AddTypeOfClaim from "../../../Components/FormComponent/AddTypeOfClaim";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";

const Dashboard = () => {
  const { t } = useTranslation();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [editTypeOfClaimId, setEditTypeOfClaimId] = useState(null);
  const {
    AuthReducer: { auth,errors,loading },
    typeOfClaimReducer: {
      typeOfClaimPermissions,
      typeOfClaimLists,
      loadingTypeOfClaim,
      errorsTypeOfClaim,
      typeOfClaimCount,
      changedTypeOfClaimStatus,
    },
  } = useSelector((state) => state);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(10);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  
  const hideModel = () => {
    setShowModal(false);
    setEditTypeOfClaimId(null);
    dispatch(getTypeOfClaimList(auth.token, paginate, page, search, sort));
  };
  
  const fetchTypeOfClaimList = useCallback(() => {
    if (auth?.token) {
      dispatch(getTypeOfClaimList(auth.token, paginate, page, search, sort));
    }
  }, [auth, paginate, page, search, sort, dispatch]);

  useDebounce(fetchTypeOfClaimList, 500, [auth, paginate, page, search, sort]);

  useEffect(() => {
    if(errors)
    {
      if(errors?.status==401)
      {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  },[errors])



  const handlePaginateChange = (e) => {
    const value = e.target.value === "All" ? typeOfClaimCount : parseInt(e.target.value);
    setPaginate(value);
    setPage(1); // Reset to the first page whenever the paginate value changes
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleDeleteRequest = (id) => {
    swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, delete it!",
    })
    .then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteTypeOfClaimData(auth?.token,id))
      }
    });
  };

  const handleStatusChangeRequest = (id, newStatus) => {
    swal.fire({
      title: "Are you sure?",
      text: `Do you want to change the status to ${newStatus}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(updateTypeOfClaimStatusData(auth.token, id, newStatus));
      }
    });
  };


  useEffect(() => {
    //console.log(changedTypeOfClaimStatus);
    if(changedTypeOfClaimStatus?.status)
    {
      swal.fire({
        show: true,
        title: "Deleted!",
        text: changedTypeOfClaimStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_TYPE_OF_CLAIM_STATUS' });
      dispatch(getTypeOfClaimList(auth?.token, paginate, page, search, sort));
    }
    else if(changedTypeOfClaimStatus?.success)
    {
      swal.fire({
        show: true,
        title: "Great !",
        text: changedTypeOfClaimStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_TYPE_OF_CLAIM_STATUS' });
      dispatch(getTypeOfClaimList(auth?.token, paginate, page, search, sort));
    }
  },[changedTypeOfClaimStatus])


  useEffect(() => {
      document.title = `Claim Type :: ${auth?.generalSettings?.title}`;
    }, []);

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Claim Type"), path: "/Type-Of-Claim", active: true },
        ]}
        title={t("Claim Type")}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                  <Col lg={3}>
                    {typeOfClaimPermissions?.filter && (<>
                      <div className="d-flex align-items-center">
                        <input
                          type="search"
                          placeholder="Search..."
                          className="form-control ms-1"
                          autoComplete="off"
                          value={search}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </>)}
                    
                  </Col>
                  <Col lg={9}>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="button-list">
                        {(typeOfClaimPermissions.add ) && (<>
                          <Button variant="success" onClick={() => {
                            setShowModal(true)
                            setEditTypeOfClaimId(null)
                          }} >
                            <i className="mdi mdi-clipboard-plus-outline me-1"></i>Add
                          </Button>
                        </>)}
                        {(typeOfClaimPermissions.print ) && (<>
                          <Button variant="dark">
                            <i className="mdi mdi-printer me-1"></i>Print
                          </Button>
                        </>)}
                        {(typeOfClaimPermissions.excel ) && (<>
                          <Button variant="info">
                            <i className="mdi mdi-file-excel me-1"></i>Excel
                          </Button>
                        </>)}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div style={{overflowY:'auto',maxHeight:'500px',border: "1px solid #dee2e6"}}>
                <Table className="mb-0 table-bordered"
                  size="sm"
                  striped
                  responsive
                  >
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th>#</th>
                      <th>Claim Type Name</th>
                      <th>Created By</th>
                      <th>Status<br /></th>
                      <th>Registered At<br /></th>
                      {(typeOfClaimPermissions.edit || typeOfClaimPermissions.delete) && (<>
                        <th>Action<br /></th>
                      </>)}
                      
                    </tr>
                  </thead>
                  <tbody>
                  {typeOfClaimLists.length === 0 ? (
                    <tr>
                      <td colSpan="6">No data found</td>
                    </tr>
                  ) : (<>
                    {typeOfClaimLists?.map?.((item, index) => {
                      return (
                        <tr key={item.id}>
                          <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                          <td>{item?.name}</td>
                          <td>{item?.createdByClaimType?.name}</td>
                          <td>{item?.status === "Active" ? <Badge className={"bg-success"}>{item?.status}</Badge> : <><Badge className={"bg-danger"}>{item?.status}</Badge></>}</td>
                          <td>{getDisplayDateTimeFormat(item?.createdAt)}</td>
                          {(typeOfClaimPermissions.edit || typeOfClaimPermissions.delete) && (<>
                            <td>
                            {(typeOfClaimPermissions.edit ) && (<>
                              {item?.status === "Active" && (
                                <>
                                  <Link to="#" className="action-icon text-success" onClick={() => handleStatusChangeRequest(item?.id , "In-Active")}>
                                    {" "}
                                    <i className="mdi mdi-eye"></i>
                                  </Link>
                                </>
                              )}
                              {item?.status === "In-Active" && (
                                <>
                                  <Link to="#" className="action-icon text-warning" onClick={() => handleStatusChangeRequest(item?.id, "Active")}>
                                    {" "}
                                    <i className="mdi mdi-eye-off"></i>
                                  </Link>
                                </>
                              )}

                              <Link to="#" onClick={() => {
                                setShowModal(true)
                                setEditTypeOfClaimId(item?.id)
                              }} className="action-icon text-info"> 
                                <i className="mdi mdi-square-edit-outline"></i>
                              </Link>
                            </>)}
                            {(typeOfClaimPermissions.delete) && (<>
                              <Link to="#" className="action-icon text-danger" onClick={() => handleDeleteRequest(item?.id)} >
                                {" "}
                                <i className="mdi mdi-delete"></i>
                              </Link>
                            </>)}
                            </td>
                          </>)}
                          
                        </tr>
                      );
                    })}</>
                  )}
                  </tbody>
                </Table>
              </div>
              <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                <div class="d-inline-block me-3">
                  <label class="me-1">Display :</label>
                  <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(typeOfClaimCount / paginate)}</strong> </span>
                <RoundedPagination currentPage={page} totalPages={Math.ceil(typeOfClaimCount / paginate)} onPageChange={(pageNumber) => setPage(pageNumber)}/>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <AddTypeOfClaim show={showModal} onHide={() => hideModel()} editId={editTypeOfClaimId}  />

      
      {loadingTypeOfClaim && (<Preloader/>)}
    </>
  );
};

export default Dashboard;
